import { FiltersProvider } from "domain/Filters";
import { CensusProvider } from "..";

export const CensusDetailsProvider = ({ children }) => (
  <FiltersProvider>
    <CensusProvider>{children}</CensusProvider>
  </FiltersProvider>
);
